<template>
<div class='main-container' :class="{'white': $route.meta.noSession, 'fullscreen': $route.meta.fullscreen, 'tbc-mode': tbcMode}">
  <headbar v-if="!tbcMode && !embedMode" />
  <hintbox v-if="!$route.meta.noSession && !embedMode && !tbcMode" />
  <router-view class='page-container'></router-view>
</div>
</template>

<script>
import Headbar from '@/components/widgets/headbar'
import Hintbox from '@/components/widgets/hintbox'

export default {
  components: {
    'headbar': Headbar,
    'hintbox': Hintbox
  }
}
</script>

<style lang="scss">
.main-container {
    min-height: 100%;
    background-color: transparent;
    &.white {
        background-color: $color-white-base;
    }

    &.fullscreen {
        min-width: $page-width-base;
    }
}

.page-container {
    background-color: transparent;
    width: $page-width-base;
    padding: $padding-page-container 0;
    margin: 0 auto;
    height: 100%;
}
.tbc-mode {
    &.main-container {
        background: white;
    }
    .project-view > .nav {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// app.vue?68e6d1cf